module.exports = __webpack_public_path__ + "img/preview-12.96cd9dbe.png";